import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { injectService } from '@patsnap/tahiti-core';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';
import { TrackService } from '@/domains/shared/services/track-service';
import { buildAiccEventDetail } from '@/presentation/utils/aicc-event-tracking';
import type {
    CcReportApi,
    CcReportRequest,
    CcReportResponse,
} from '../cc-report-api';

/**
 * CC 结构化结果报告接口实现。
 */
@injectable()
export class CcReportApiImpl extends GuestAwareHttpService implements CcReportApi {
    /**
     * 查询参数严格使用接口文档定义的 task_id，不额外传递页面字段。
     */
    async getReport(request: CcReportRequest): Promise<CcReportResponse> {
        const response = await this.getWithGuestSupport<CcReportResponse>(
            'cc_compare/report',
            {
                task_id: request.task_id,
            }
        );

        if (response.status) {
            this.trackTaskFinished(request.task_id);
        }

        return response;
    }

    private trackTaskFinished(taskId: string) {
        const trackService = injectService<TrackService>(TrackService);
        trackService.trackAir({
            event_type: 'ss_telecom',
            source_type: 'telecom_aicc_task_finished',
            session_id: taskId,
            other_param: 'aicc',
            event_detail_str: buildAiccEventDetail('/essentiality-claim/flow/conclusion', {
                taskId,
            }),
        }).catch(error => {
            console.warn('[CcReportApi] Failed to track task_finished:', error);
        });
    }
}
